"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthService = void 0;
const cognito_service_1 = require("./cognito.service");
const database_auth_service_1 = require("./database-auth.service");
/** One service instance per application; only the selected provider is created. */
function createAuthService(options) {
    if (options.mode === 'cognito') {
        if (!options.cognito)
            throw new Error('Cognito authentication requires a configured SDK.');
        return new cognito_service_1.CognitoAuthService(options.cognito);
    }
    return new database_auth_service_1.DatabaseAuthService(options.baseUrl, options.fetcher);
}
exports.createAuthService = createAuthService;
